// Rails' CSRF token from the <meta name="csrf-token"> tag. Inertia's router
// injects it automatically, but a bare `fetch` to a non-GET endpoint must send
// it itself — read it here so every raw fetch shares one source of truth.
export function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
}

// Replace the page's token — for a raw fetch the server answered with a fresh
// one because the session's token rotated under an open page (a sign-in in
// another tab). Every later reader of csrfToken() then sends the new one.
export function setCsrfToken(token: string): void {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
  if (meta) meta.content = token
}

// A page's token goes stale when its session cookie does — a phone that killed
// the browser while the applicant was in a UPI app or Gmail restores the tab with
// the old token and no cookie. This asks the server for a fresh one (the response
// also re-sets the cookie it belongs to) and writes it back into the meta tag, so
// every later request on the page uses it too. Null when it cannot be fetched.
export async function refreshCsrfToken(): Promise<string | null> {
  try {
    const res = await fetch('/applications/csrf_token', { credentials: 'same-origin', cache: 'no-store' })
    if (!res.ok) return null
    const { token } = (await res.json()) as { token?: string }
    if (!token) return null
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.setAttribute('content', token)
    return token
  } catch {
    return null
  }
}
